import moment from 'moment';
import { IAddress, AddressModel } from "../Address"
import { TenantUserFields } from "../TenantUserFields";
import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { HumanModel } from "./Human";
import { TaskItemModel } from "./GanttChart/TaskItem";
import { PositionModel } from "./GanttChart/PositionModel";



export class WorkprocessModel extends Model  {
    id: number;
    parent: number;
    name: string = "";
    work_sector_id: number;
    organization_sector_id: number;
    ancestry: string;
    process_type: string;
    enabled:boolean = true;
    estimated_hours = 0
    estimated_minutes:number = 0;
    estimated_total:number = 0;
    start_date:number;
    end_date:number;
    total_hours = 0
    total_min:number = 0;
    level:number = 1;
    startdate_str:string = "";
    enddate_str:string = "";
    position: PositionModel = new PositionModel();
    
    constructor(data = null) {
        super();
        
        if(data) {
            this.createModel(data, {items: WorkprocessModel, position: PositionModel});
            this.checkLevel();
            
            if(!this.estimated_minutes) {
                this.estimated_minutes = 0;
            }
            if(!this.estimated_hours) {
                this.estimated_hours = 0;
            }
            
        }
        
    }
    
    public checkLevel() {
        if(this.ancestry && this.ancestry != "") {
            const parentIds = this.ancestry.split(".");
            if(parentIds && Array.isArray(parentIds) && parentIds.length > 0) {
                this.level = parentIds.length;
            } 
        }
    }
    
    public getParentIds() {
        if(this.ancestry && this.ancestry != "") {
            const parentIds = this.ancestry.split(".");
            if(parentIds && Array.isArray(parentIds) && parentIds.length > 0) {
                return parentIds; 
            } 
        }
        
    }
    
    public getStartDate() {
        let retVal;
        retVal = moment(this.start_date);
        return retVal; 
    }

    public setStartDate(val) {
        if(typeof val == 'object') {
            this.start_date = val.utc().valueOf();
            this.startdate_str = val.utc().format("DD-MM-YYYY hh:mm:ss");
        } else if(typeof val == 'number') {
            this.start_date = val;
        }
        return this.start_date; 
    }
    
    public addDays(val) {
        let selectedDate = this.getStartDate();
        selectedDate.add('day', val);
        this.setStartDate(selectedDate);
        
        selectedDate = this.getEndDate();
        selectedDate.add('day', val);
        this.setEndDate(selectedDate);        
    }
    

    public getEndDate() {
        let retVal;
        retVal = moment(this.end_date);
        return retVal; 
    }

    public setEndDate(val) {
        this.end_date = val.utc().valueOf();;
        this.enddate_str = val.utc().format("DD-MM-YYYY hh:mm:ss");
        return this.end_date; 
    }
    
}